import API from '@/services/api'

export default {
  getUtilities() {
    return API.get('/utilities')
  },
  getUtility(id) {
    return API.get('/utilities/' + id)
  }
}
